import React, { useContext } from 'react'
import { SideNav, SideNavItem, SideNavHeading } from '@react/react-spectrum/SideNav'
import { EasybakeContext } from '../EasybakeProvider'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'

export default function Nav () {
    const { page, ut, dispatch } = useContext(EasybakeContext)
    return (
        <div className="adobe-easybake-nav">
            <SideNav className="sideNav" onSelect={page => dispatch({ type: 'set-page', payload: { page } })}>
                <SideNavHeading className="sideNavHeading" label={__('nav_title')}>
                    <SideNavItem className="sideNavItem" value="psactions" label={__('psactions_nav_title')} />
                    <SideNavItem className="sideNavItem" value="autotone" label={__('autotone_nav_title')} />
                    <SideNavItem className="sideNavItem" value="preset" label={__('preset_nav_title')} />
                    <SideNavItem className="sideNavItem" value="smartobject" label={__('smartobject_nav_title')} />
                    <SideNavItem className="sideNavItem" value="textlayer" label={__('textlayer_nav_title')} />
                    <SideNavItem className="sideNavItem" value="imagecutout" label={__('imagecutout_nav_title')} />
                </SideNavHeading>
            </SideNav>
            <div className="adobe-easybake-nav-content"></div>
        </div>
    )
}
